<template>
  <section class="app-container">
    <div class="container">
      <div class="taxonomy-component">
          <h1>Records</h1>
          <paging></paging>
          <table v-show="!loading" class="border--round table--alternate-row">
            <thead>
              <tr>
                <th>ID</th>
                <th>Common Name</th>
                <th>Scientific Name</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="taxon in taxa.results" :key="taxon.id">
                <td>{{taxon.id}}</td>
                <td class="notranslate" translate="no">{{taxon.common_name}}</td>
                <td class="notranslate" translate="no">{{taxon.scientific_name}}</td>
                <td>{{taxon.author}}, {{taxon.year}}</td>
              </tr>
            </tbody>
          </table>
          <paging v-show="!loading"></paging>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'TaxonomyPage',
  data: function(){
    return {
      taxa: {
        results: [],
        count: 0
      },
      page: 1,
      page_size: 25,
      loading: true
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData: function(){
      var self = this;
      $.getJSON("https://ocapi.staging.birdsinthehand.com/taxa/?format=json&page=" + self.page, function( data ) {
        self.loading = false;
        self.taxa = data;
      });
    }
  },
  computed: {
    max_page: function(){
      return Math.ceil(this.taxa.count / this.page_size);
    }
  },
  watch:{
    page: function(){
      this.loading = true;
      this.getData();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Taxonomy.vue